import { FC } from 'react';

import classes from './EmptyState.module.scss';

export interface EmptyStateProps {
  title: string;
  subtitle: string;
  icon: string;
}

const EmptyState: FC<EmptyStateProps> = ({ title, subtitle, icon }) => {
  return (
    <div className={classes.Container}>
      <img src={icon} alt="empty-state" />
      <h6>{title}</h6>
      <p>{subtitle}</p>
    </div>
  );
};

export default EmptyState;
